export const BaseUrlLink = process.env.SHOP_API || 'https://shop.customessaymeister.com'